import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const getPayrollRegister = async (runId) => {
  const res = await axiosInstance.get(`/api/payroll/reports/register/${runId}`);
  return res.data;
};

export const getSalaryRegister = async (month, year) => {
  const res = await axiosInstance.get("/api/payroll/reports/salary-register", {
    params: { month, year },
  });
  return res.data;
};

export const getBankTransferFile = async (runId) => {
  const res = await axiosInstance.get(`/api/payroll/reports/bank-transfer/${runId}`);
  return res.data;
};

export const getStatutoryReport = async (runId) => {
  const res = await axiosInstance.get(`/api/payroll/reports/statutory/${runId}`);
  return res.data;
};

export const getYearEndSummary = async (year) => {
  const res = await axiosInstance.get("/api/payroll/reports/year-end", {
    params: { year },
  });
  return res.data;
};
